module.exports = __webpack_public_path__ + "img/rxk_img4.255d4e86.png";